import React, { useContext } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';

import { DeviceContext } from '@vyce/core/src/contexts';
import { MAIN_CONTAINER_ID } from '@vyce/core/src/constants';
import { ButtonTitleWithLoading } from '@vyce/core/src/components/ButtonTitleWithLoading';

interface Props {
  open: boolean;
  setOpen: Function;
  loading: boolean;
  confirmFunction: () => void;
}

export const ConfirmMessagingSubscriptionDialog: React.FC<Props> = ({
  open,
  setOpen,
  confirmFunction,
  loading,
}) => {
  const { isMobile } = useContext(DeviceContext);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      container={document.getElementById(MAIN_CONTAINER_ID)}
      fullScreen={isMobile}
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>Almost there...!</DialogTitle>

      <DialogContent>
        <DialogContentText>
          You’re just about to empower your team and business with Vyce Messaging. Exciting. Going forward
          you’ll be charged £199.00 + VAT per month for this module. You can cancel at any time. 
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={() => setOpen(false)}>
          Cancel
        </Button>

        <Button
          style={{ width: 120 }}
          disabled={loading}
          onClick={confirmFunction}
          color="primary"
          variant="contained"
        >
          <ButtonTitleWithLoading title="OK, Let’s go!" loaderVariant="paper" loading={loading} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
